import { render, staticRenderFns } from "./company_settle_table.vue?vue&type=template&id=f9d882c4&scoped=true"
import script from "./company_settle_table.vue?vue&type=script&lang=ts"
export * from "./company_settle_table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d882c4",
  null
  
)

export default component.exports